<template>

  <div class="" v-if="requesters.length > 0">
    <div class="section-header">
      <h3 class="section-title">{{ $t("globals.requesters") }} ( MyEnv order )</h3>
    </div>
    <div class="table-wrapper">
      <table class="modern-table">
        <thead>
          <tr>
            <th>{{ $t("globals.email") }}</th>
            <th>{{ $t("globals.first_name") }}</th>
            <th>{{ $t("globals.last_name") }}</th>
            <th>{{ $t("globals.external_user_id") }}</th>
            <th>{{ $t("globals.created_at") }}</th>
            <th>{{ $t("globals.notes") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="requester in requesters" :key="requester.id">
            <td>{{ requester.email }}</td>
            <td>{{ requester.first_name }}</td>
            <td>{{ requester.last_name }}</td>
            <td>{{ requester.external_user_id }}</td>
            <td>{{ new Date(requester.created_at).toLocaleString() }}</td>
            <td>{{ requester.notes }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      requesters: [],
    };
  },

  computed: {
    ...mapGetters(["getGraphQlUrl", "getDefConf"]),
  },

  methods: {
    async fetchRequester() {
      try {
        const id = parseInt(this.$route.params.id);

        const { data } = await axios.post(
          this.getGraphQlUrl,
          {
            query: `
              query {
                  order (id: ${id}) {
                  requesters {
                    id
                    email
                    first_name
                    last_name
                    external_user_id
                    created_at
                    notes
                  }
                }
              }
            `,
            variables: { id },
          },
          this.getDefConf
        );

        if (data.errors?.length) {
          throw new Error(data.errors[0].message);
        }

        this.requesters = data.data.order?.requesters || [];
      } catch (err) {
        alert(err.message || err);
        console.error(err);
      }
    },
  },

  mounted() {
    this.fetchRequester();
  },
};
</script>
